import React from 'react';
import { useAppSelector } from '../../../store/hooks';

const DashboardHeader = ({ onMenuToggle }) => {
  const { user } = useAppSelector((state) => state.auth);

  return (
    <div className="fixed top-0 left-0 right-0 h-[60px] bg-white border-b border-jet-gray-200 flex justify-between items-center px-4 md:px-8 z-[100] font-['Bahnschrift_Light','Segoe_UI',Tahoma,Geneva,Verdana,sans-serif]">
      <div className="flex items-center gap-2.5">
        {/* Hamburger Menu Icon - Mobile Only */}
        <button
          onClick={onMenuToggle}
          className="md:hidden p-2 hover:bg-gray-100 rounded-md transition-colors"
          aria-label="Toggle menu"
        >
          <svg
            className="w-6 h-6 text-gray-700"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path d="M4 6h16M4 12h16M4 18h16"></path>
          </svg>
        </button>
        
        <img src="/jetscanner-logo.svg" alt="JetScanner360" className="h-8 w-auto" />
      </div>
      <div className="flex items-center gap-3 py-1.5 px-2 rounded-full text-[13px]">
        {/* User Profile Image/Avatar */}
        <div className="w-8 h-8 rounded-full bg-[#ffd200] flex items-center justify-center overflow-hidden border border-gray-100 shadow-sm flex-shrink-0">
          {user?.image_url ? (
            <img 
              src={user.image_url} 
              alt="Profile" 
              className="w-full h-full object-cover text-[10px]"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = ''; // Force switch to fallback initial
              }}
            />
          ) : (
            <span className="text-[14px] font-bold text-black uppercase">
              {user?.first_name ? user.first_name.charAt(0) : (user?.email?.charAt(0) || 'U')}
            </span>
          )}
        </div>
        
        {/* User Name */}
        <span className="hidden sm:inline font-bold text-gray-800 uppercase tracking-tight">
          {user ? `${user.first_name || ''} ${user.last_name || ''}`.trim() || user.email || 'USER' : 'USER'}
        </span>
      </div>
    </div>
  );
};

export default DashboardHeader;
